<template>
    <div id="app" :ui-is-loading="loading">
        <div class="container">
            <router-view/>
        </div>
        <progress-bar :running="loading"/>
    </div>
</template>

<script>
	import { subscribe as subscribeToApi } from './api/rest';
	import progressBar from './components/progress-bar.vue';
	
	export default {
		name: 'app',
		components: { progressBar },
		data() {
			return {
				loadingCount: 0
			};
		},
		computed: {
			loading() {
				return this.loadingCount > 0;
			}
		},
		mounted() {
			subscribeToApi(request => {
				this.loadingCount += 1;
				request
					.then(() => {
						this.loadingCount -= 1;
					})
					.catch(err => {
						this.loadingCount -= 1;
						if(err){
							this.$q.notify({
								type: 'negative',
								message: err,
								icon: 'error-outline',
								timeout: 12000
							});
						}
					});
			});
		}
	};
</script>
